import SpotInnovationLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-innovation-light.svg';
import clsx from 'clsx';

import { AnimatedText } from '@components/AnimatedText';

interface StringArrayBundleBotProps {
  text: string[];
  onComplete?: () => void;
  className?: string;
}

/**
 * Legacy BundleBot implementation for string[] input
 * Maintains backward compatibility with existing usage patterns
 */
const StringArrayBundleBot = ({
  text,
  onComplete,
  className,
}: StringArrayBundleBotProps) => (
  <div
    data-testid="bundle-bot"
    className={clsx('bundleBot_wrapper', className)}
  >
    <div className="bundleBot">
      <div className="bundleBot_img">
        <img src={SpotInnovationLight} alt="Bundle Bot" />
      </div>
      <div className="bundleBot_textContainer">
        <AnimatedText text={text} once onComplete={onComplete} />
      </div>
    </div>
  </div>
);

export { StringArrayBundleBot };
